import { useMatch } from "react-router-dom";
import { DEMO_ROUTES } from "@/_old/constants/routes";

export const useDemo = () => {
  const match = useMatch({ path: DEMO_ROUTES.INDEX, end: false });

  return { isDemo: !!match };
};
